<template>
    <v-layout class="mt-3">
        <v-flex xs12>
            <v-card class="mx-auto" flat>
                <confirmation-header-text
                    text="NRN Visa Details"
                    class="ml-0"
                    icon="mdi-map-marker-radius"></confirmation-header-text>

                <v-card-text>
                    <v-layout row wrap>
                        <v-flex xs12 sm6>
                            <address-auto-complete
                                :label="'Full address of '+ visa.traveller.country_name"
                                :rules="[rules.required]"
                                v-model="visa.extra.application_data.full_address"/>
                        </v-flex>
                        <v-flex xs12 xs6 class="pl-2">
                            <address-auto-complete
                                label="Full address of Nepal"
                                :rules="[rules.required]"
                                v-model="visa.extra.application_data.full_address_nepal"
                            />
                        </v-flex>
                        <v-flex xs12 xs6 >
                            <v-text-field
                                outlined
                                v-model="visa.extra.application_data.nrn_card_number"
                                label="NRN card number"
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12 sm6 class="pl-5">
                            <new-date-picker
                                label="NRN Card expiry date"
                                v-model="visa.extra.application_data.nrn_card_expiry_date"
                                :watch-value="true"
                            />
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-flex>
    </v-layout>
</template>

<script>
    import AddressAutoComplete from "../../AddressAutoComplete";
    import ConfirmationHeaderText from "../../ConfirmationHeaderText";
    import NewDatePicker from "../../NewDatePicker";

    export default {
        name: 'NRNVisa',
        data: () => ({
            rules: {
                required: value => !!value || "Required."
            },
        }),
        components: {
            NewDatePicker,
            "address-auto-complete": AddressAutoComplete, ConfirmationHeaderText
        },
        computed: {
            visa() {
                return this.$store.state.VisaRequestSingle.visaRequest;
            },
        },
    }
    ;
</script>
